import { render, staticRenderFns } from "./PageSettingsBackgroundImageSettings.vue?vue&type=template&id=22582538"
import script from "./PageSettingsBackgroundImageSettings.vue?vue&type=script&lang=ts"
export * from "./PageSettingsBackgroundImageSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22582538')) {
      api.createRecord('22582538', component.options)
    } else {
      api.reload('22582538', component.options)
    }
    module.hot.accept("./PageSettingsBackgroundImageSettings.vue?vue&type=template&id=22582538", function () {
      api.rerender('22582538', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/document-settings/PageSettingsBackgroundImageSettings.vue"
export default component.exports